import { render, staticRenderFns } from "./v12.vue?vue&type=template&id=5a656035&scoped=true&"
import script from "./v12.vue?vue&type=script&lang=js&"
export * from "./v12.vue?vue&type=script&lang=js&"
import style0 from "./v12.vue?vue&type=style&index=0&id=5a656035&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a656035",
  null
  
)

export default component.exports